// fetch color from color metaobjects
function getColorOptionsCached() {
  const url = 'https://shopify-otech.matat.io/api/metaobjects/all?shop_domain=new-dreadlocks.myshopify.com&type=add_color_options';
  const CACHE_KEY = 'color_metaobjects_cache';
  const CACHE_TTL = 1000 * 60 * 10; // 10 minutes

  const now = Date.now();
  const cached = JSON.parse(localStorage.getItem(CACHE_KEY) || '{}');

  // Use cached data if not expired
  if (cached.data && cached.timestamp && (now - cached.timestamp < CACHE_TTL)) {
    applyColorOptions(cached.data);
  } else {
    // Fetch new data and cache it
    fetch(url, { headers: { 'Content-Type': 'application/json' } })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
        return response.json();
      })
      .then(data => {
        localStorage.setItem(CACHE_KEY, JSON.stringify({
          data: data.data?.metaobjects || [],
          timestamp: Date.now()
        }));
        applyColorOptions(data.data?.metaobjects || []);
      })
      .catch(error => {
        console.error('Fetch error:', error);
        if (cached.data) {
          console.warn('Using stale cached data due to fetch error.');
          applyColorOptions(cached.data);
        }
      });
  }

  function applyColorOptions(metaobjects) {
    
    // Build lookup map for faster access
    const colorMap = new Map();
    for (const obj of metaobjects) {
      const key = obj.displayName?.trim().toLowerCase();
      if (key) colorMap.set(key, obj.fields);
    }
    // console.log(colorMap)
    // return true;
    const items = document.querySelectorAll('.variation-item');
    const updates = [];

    items.forEach((item) => {
      if(item.querySelector("input[type='radio']")){
        const colorName = item.querySelector("input[type='radio']").getAttribute('data-sku')?.trim();
        const colorcodeload = colorName?.split("--")[1]?.toLowerCase();
        const span = item.querySelector('.variation-item-span');
        if (!colorcodeload || !span) return;
        // console.log(colorcodeload)

        const fields = colorMap.get(colorcodeload);
        // console.log(fields)

        if (fields) {
          updates.push(() => {
            const colorImage = fields.color_image?.url;
            const colorCode = fields.color_code;
            if (colorImage) {
              span.style.backgroundImage = `url(${colorImage})`;
              span.style.backgroundSize = 'cover';
              span.style.backgroundPosition = 'center';
            } else if (colorCode) {
              span.style.backgroundColor = colorCode;
            }
          });
        }
      }
    });

    requestAnimationFrame(() => {
      for (const update of updates) update();
    });
  }
}
getColorOptionsCached();

function getFocusableElements(container) {
  if(container){
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
}

const onmouseleaveHandeler = (e) => {
  if(e.classList.contains('variant_image_active')) {
    e.classList.remove('variant_image_active');
  }
}

(()=>{
  // let flickityList = document.querySelectorAll('[data-flickity]');

  // for (let i = 0, t = flickityList.length; i < t; i++) {
  //     let flkty = Flickity.data(flickityList[i]);
  //     if (flkty) {
  //       let vimeo_iframe = flkty.selectedElement.querySelector('iframe');

  //       if(vimeo_iframe) {
  //         let player = new Vimeo.Player(vimeo_iframe);
  //         player.on('loaded', (e) => {
  //           player.getPaused().then(function(paused) {
  //             if(paused) {
  //               player.play();
  //             }
  //           });
  //         });
  //       } else {
  //         return false;
  //       }
  //     }
  // }
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if(window.innerWidth > 750){
    if(summary.closest('header-menu')){
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
          if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.setAttribute('open', 'true');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
          }
        
      });
      
      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
          if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
            detailsElement.removeAttribute('open');
            event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
          }
      });
    }
  }
  
  summary.addEventListener('click', (event) => {
    if (summary.classList.contains('matat_filters__summary')) {
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
        const sliderWrapper = document.getElementById('matat-range-slider');
          if (sliderWrapper.rangeable) {
            sliderWrapper.rangeable.destroy?.(); // Optional chaining
            sliderWrapper.style.display = 'none';
            sliderWrapper.offsetHeight; // force reflow
            sliderWrapper.style.display = '';
            MatatFiltersForm.priceRangeSlider(); // re-init
          }
      }
      if(summary.closest('.product__accordion')){ 
        const detailsElement = summary.closest("details");
        if (detailsElement && !detailsElement.hasAttribute("open")) {
          document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
              openDetail.removeAttribute("open");
          });
        }
      }
      if(document.querySelector(".header__search details").hasAttribute("open")){
        // console.log("remove open")
        document.querySelector(".header__search details").removeAttribute("open")
      }
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  // document.querySelectorAll('.js-youtube').forEach((video) => {
  //   video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  // });
  // document.querySelectorAll('.js-vimeo').forEach((video) => {
  //   video.contentWindow.postMessage('{"method":"pause"}', '*');
  // });
  // document.querySelectorAll('video').forEach((video) => video.pause());
  // document.querySelectorAll('product-model').forEach((model) => {
  //   if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    this.loadContent();
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

document.body.addEventListener('click', function (e) {
    let target = e.target;
    if(target.classList.contains('custom_variation_button')) {
      // Sold-out cards render the swatch row without the inline variation form
      // (see card-product.liquid), so every lookup here has to tolerate a missing
      // node - this handler also runs programmatically for the default swatch.
      let parentItem = target
        .closest('.product-card-wrapper')
        ?.querySelector('.product-card_inline-variation .product-form__input.listen_color_change');
      // Matched by value instead of an attribute selector: option values contain
      // spaces and quotes that would break `[value="..."]`.
      let actual_var_item = parentItem
        ? Array.from(parentItem.querySelectorAll('input')).find((input) => input.value === target.value)
        : null;
      if (actual_var_item) {
          actual_var_item.checked = true;
          parentItem.dispatchEvent(new CustomEvent('color_change',{'detail': target.value}));
          actual_var_item.dispatchEvent(new Event('custom_change'));
      }
          // let variant_radios = target.closest('.product-card-wrapper').querySelector('variant-radios');
          // variant_radios.dispatchEvent(new Event('change'));
      // target.closest('.product-card-wrapper').querySelector(".card__media.enable_image_slider .loading-overlay__spinner").classList.remove("hidden");
      // setTimeout(() => {
      //   target.closest('.product-card-wrapper').querySelector(".card__media.enable_image_slider .loading-overlay__spinner").classList.add("hidden");
      // }, "1000");
      // console.log("variant change")
    }
    if(target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
      if(target.tagName.toUpperCase() == 'INPUT') {
        target.closest('variant-radios').dispatchEvent(new Event('change'));
      }
    }
});

// Assuming these Swiper instances exist globally or are accessible
// let mainSwiper;
// let thumbSwiper;

// function initializeSwipers() {
//   // Main Swiper
//   mainSwiper = new Swiper('.product-slider-gallery', {
//    loop: true,
//     spaceBetween: 0,
//     rtl: true,
//     navigation: {
//       nextEl: ".swiper-button-next",
//       prevEl: ".swiper-button-prev",
//     },
//     thumbs: {
//       swiper: swiper,
//     },
//   });

//   // Thumbnail Swiper
//   thumbSwiper = new Swiper('.thumbnail_slider_side', {
//     loop: true,
//     spaceBetween: 0,
//     slidesPerView: 4,
//     freeMode: true,
//     watchSlidesProgress: true,
//     rtl: true,
//   });

//   // Re-link main with thumbnail
//   mainSwiper.params.thumbs.swiper = thumbSwiper;
//   mainSwiper.thumbs.init();
//   mainSwiper.thumbs.update();
// }



  // Thumbnail Swiper
    
  // this.thumbSwiper = new Swiper('.thumbnail_slider_side', {
  //   loop: false,
  //   spaceBetween: 0,
  //   slidesPerView: 4,
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   rtl: true,
  // });

  // this.mainSwiper = new Swiper('.product-slider-gallery', {
  //  loop: false,
  //   spaceBetween: 0,
  //   rtl: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   thumbs: {
  //     swiper: thumbSwiper,
  //   },
  // });

  // var swiper = new Swiper(".thumbnail_slider_side", {
  //   loop: true,
  //   spaceBetween: 0,
  //   slidesPerView: 4,
  //   freeMode: true,
  //   watchSlidesProgress: true,
  //   rtl: true,
  // });
  // var swiper2 = new Swiper(".product-slider-gallery", {
  //   loop: true,
  //   spaceBetween: 0,
  //   rtl: true,
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   thumbs: {
  //     swiper: swiper,
  //   },
  // });

document.addEventListener("click", function(e) {
  const btn = e.target.closest(".quick_add_cart .variant-button");
  if (!btn) return;

  const input = btn.querySelector("input.select_color");
  const tooltip = btn.querySelector(".variant-tooltip");

  if (input && tooltip) {
      tooltip.classList.add("show-tooltip"); // your custom class
      // Remove class after 2 seconds
      setTimeout(() => {
          tooltip.classList.remove("show-tooltip");
      }, 2000);
  }
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    
    this.addEventListener('change', this.onVariantChange);

    if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      // if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
      //   this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
      //     // Updating Variant Button
      //     const variant_details = this.getVariantDetails(e.detail);
      //     const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
      //     var $this = this;
      //     $variant_input.forEach(function(input){
      //       var this_value = input.getAttribute('value');
      //       switch(input.getAttribute('data-option')) {
      //         case "1":
      //           var condition = variant_details.find((x)=>{
      //               return x.available && x.option1 == this_value
      //           });
      //           $this.updateVariantButton(condition, input)
      //           break;
      //         case "2":
      //           var condition = variant_details.find((x)=>{
      //               return x.available && x.option2 == this_value
      //           });
      //           $this.updateVariantButton(condition, input)
      //           break;
      //         case "3":
      //           var condition = variant_details.find((x)=>{
      //               return x.available && x.option3 == this_value
      //           });
      //           $this.updateVariantButton(condition, input)
      //           break;
      //         default:
      //       }
      //     });
      //   });
      // }
      if (
        this.querySelector('.product-form__input.listen_color_change') &&
        this.querySelector('.product-form__input.image_switcher_activated')
      ) {
        this
          .querySelector('.product-form__input.listen_color_change')
          .addEventListener('color_change', (e) => {

            /* -----------------------------------------
            *  ⭐ YOU WANTED TO KEEP THESE LINES
            * -----------------------------------------
            */
            const card = this.closest(".card-wrapper");

            if (card) {
              card.querySelectorAll(".card__content .card-mobile-quickview")
                .forEach(el => el.classList.remove("select_color"));
            }
            /* -----------------------------------------
            */

            // ========== EXISTING VARIANT CODE ==========
            const variant_details = this.getVariantDetails(e.detail);
            const $variant_input = this
              .closest('.product_quick_add_wrap')
              .querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');

            var $this = this;

            $variant_input.forEach(function (input) {
              input.classList.remove('select_color');
              var this_value = input.getAttribute('value');

              switch (input.getAttribute('data-option')) {
                case "1":
                  var condition = variant_details.find((x) => {
                    return x.available && x.option1 == this_value;
                  });
                  $this.updateVariantButton(condition, input);
                  break;

                case "2":
                  var condition = variant_details.find((x) => {
                    return x.available && x.option2 == this_value;
                  });
                  $this.updateVariantButton(condition, input);
                  break;

                case "3":
                  var condition = variant_details.find((x) => {
                    return x.available && x.option3 == this_value;
                  });
                  $this.updateVariantButton(condition, input);
                  break;

                default:
              }
            });

          });
      }

      // document.querySelectorAll('.card-variation-color input').forEach(input => {
      //   input.addEventListener('change', (e) => {
      //     if (!e.target.checked) return;
      
      //     const selectedSku = e.target.dataset.sku;
      //     const partsSku = selectedSku.split('--');
      //     const matchSku = partsSku.length >= 2 ? `${partsSku[0]}--${partsSku[1]}` : selectedSku;
          
      //     const card_wrapper = e.target.closest('.card-wrapper'); // ✅ Finds the parent card
      //     if (!card_wrapper) {
      //       console.warn('No .card-wrapper found');
      //       return;
      //     }
      
      //     const card_inner = card_wrapper.querySelector('.card__inner'); // ✅ Scoped inside wrapper
      //     if (!card_inner) {
      //       console.warn('No .card__inner inside .card-wrapper');
      //       return;
      //     }
      
      //     const flickityGrid = card_inner.querySelector('.card__media .flickity_grid');
      //     const flkty = flickityGrid ? Flickity.data(flickityGrid) : null;
      
      //     if (!flkty) {
      //       console.warn('Flickity not initialized');
      //       return;
      //     }
      //     let matchingSlide = "";
      //     // for (let e of card_inner.querySelectorAll(`.card__media .pro-media`)) {
      //     //   let altimage = e.getAttribute('data-image-alt') || '';
      //     //   console.log({altimage});
      //     //   console.log({selectedSku});
      //     //   let partsSkualtcard = altimage ? altimage.split(/--|-/) : [];
      //     //   let matchSkualtcard = partsSkualtcard.length >= 2 
      //     //     ? partsSkualtcard[0] + '--' + partsSkualtcard[1] 
      //     //     : selectedSku;
          
      //     //   if (matchSkualtcard === matchSku) {
      //     //     matchingSlide = e;
      //     //     break;
      //     //   }
      //     // }
      //     //swaches for the product search card update js
      //     for (let e of card_inner.querySelectorAll(`.card__media .pro-media`)) {
      //       let altimage = e.getAttribute('data-image-alt') || '';
      //       let normalizedAlt = altimage.replace(/--|-/g, '--');
      //       let normalizedSku = selectedSku.replace(/--|-/g, '--');
      //       let partsAlt = normalizedAlt.split('--');
      //       let partsSku = normalizedSku.split('--');
      //       let matchSkualtcard = partsAlt.slice(0, -1).join('--');
      //       let matchSkuSelected = partsSku.slice(0, -1).join('--');
            
      //       if (matchSkualtcard === matchSkuSelected) {
      //         matchingSlide = e;
      //         break;
      //       }
      //     }
      //     //swaches for the product search card update js
      //     if (matchingSlide) {
      //       const targetIndex = parseInt(matchingSlide.dataset.index, 10);
      //       flkty.select(targetIndex);
      //     } else {
      //       console.warn('No matching slide found 1');
      //     }
      //   });
      // });
      
      document.querySelectorAll('.card-variation-color input').forEach(input => {
        input.addEventListener('change', (e) => {
          if (!e.target.checked) return;

          const selectedSku = e.target.dataset.sku;
          const partsSku = selectedSku.split('--');
          const matchSku = partsSku.length >= 2 ? `${partsSku[0]}--${partsSku[1]}` : selectedSku;
          
          const card_wrapper = e.target.closest('.card-wrapper');
          if (!card_wrapper) {
            console.warn('No .card-wrapper found');
            return;
          }

          const card_inner = card_wrapper.querySelector('.card__inner');
          if (!card_inner) {
            console.warn('No .card__inner inside .card-wrapper');
            return;
          }

          // Check if Flickity is enabled
          const flickityGrid = card_inner.querySelector('.card__media .flickity_grid');
          const flkty = flickityGrid ? Flickity.data(flickityGrid) : null;

          let matchingSlide = null;
          // function normalizeCode(str) {
          //   let parts = str.split(/-+/g);   // split on single or double dashes
          //   const first = parts[0];         // keep as is

          //   // middle parts = everything except first + last
          //   const middle = parts.slice(1, -1).join('');

          //   return `${first}--${middle}`;
          // }
          // Find matching slide
          const mediaSelector = flkty ? `.card__media .pro-media` : `.card__media .media img`;
          for (let e of card_inner.querySelectorAll(mediaSelector)) {
            let altimage = e.getAttribute('data-image-alt') || '';
            // let normalizedAlt = altimage.replace(/--|-/g, '--');
            // let normalizedAlt = normalizeCode(altimage);
            // let normalizedSku = selectedSku.split('--').map(p => p.replace(/-/g, '')).join('--');
            // let normalizedSku = normalizeCode(selectedSku);
            // let partsAlt = normalizedAlt.split('--');
            // let partsSku = normalizedSku.split('--');
            // let matchSkualtcard = partsAlt.slice(0, -1).join('--');
            // let matchSkuSelected = partsSku.slice(0, -1).join('--');
            
            // console.log('matchSkualtcard', matchSkualtcard, 'matchSkuSelected', matchSkuSelected);
            // if (matchSkualtcard === matchSkuSelected) {
              // console.log('normalizedSku', normalizedSku, 'normalizedAlt', normalizedAlt);
              // matchingSlide = e;
              // break;
              let matchSkualt;
              if (altimage.includes('--')) {
                // Already has double dash: PON--801-1 → PON--801
                const parts = altimage.split('--');
                const secondPart = parts[1].split('-')[0];
                matchSkualt = parts[0] + '--' + secondPart;
              } else {
                // Single dash format
                const parts = altimage.split('-');
                // Check if third part is purely numeric (image number) or contains letters (variant/color code)
                if (parts.length >= 3 && !/^\d+$/.test(parts[2])) {
                  // Third part contains letters: YAROK-YA-G-2 → YAROK--YA-G
                  matchSkualt = parts[0] + '--' + parts[1] + '-' + parts[2];
                } else if (parts.length >= 2) {
                  // Simple format: PON-8-1 or PON-549B-3 → PON--8 or PON--549B
                  matchSkualt = parts[0] + '--' + parts[1];
                } else {
                  // matchSkualt = selected_sku;
                  matchSkualt = selectedSku;      
                }
              }
                if (matchSkualt === matchSku) {
                // console.log('matchSkualt', matchSkualt, 'matchSku', matchSku);
                matchingSlide = e;
                break;
              }
          }

          // console.log("matchingSlide", matchingSlide);

          if (matchingSlide) {
            if (flkty) {
              // Flickity is enabled - use carousel navigation
              const targetIndex = parseInt(matchingSlide.dataset.index, 10);
              console.log('targetIndex', targetIndex)
              flkty.select(targetIndex);
            } else {
              // Flickity is disabled - handle image switching manually
              const allMedia = card_inner.querySelectorAll('.card__media .media .pro-media');
              
              // Hide all media elements
              allMedia.forEach(media => {
                media.style.opacity = '0';
              });
              
              // Show only the matching slide
              matchingSlide.style.opacity = '1';
            }
          } else {
            console.warn('No matching slide found');
          }
        });
      });

      // on load change the size options js starst from here
      let load_selected_color_option = this.querySelector(".listen_color_change").querySelector("input:checked").value;
      let var_details_load = this.getVariantDetails(load_selected_color_option);
      let load_variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
      var load_this = this;
      load_variant_input.forEach(function(input){
        var this_value = input.getAttribute('value');
        switch(input.getAttribute('data-option')) {
          case "1":
            var condition = var_details_load.find((x)=>{
                return x.available && x.option1 == this_value
            });
            load_this.updateVariantButton(condition, input)
            break;
          case "2":
            var condition = var_details_load.find((x)=>{
                return x.available && x.option2 == this_value
            });
            load_this.updateVariantButton(condition, input)
            break;
          case "3":
            var condition = var_details_load.find((x)=>{
                return x.available && x.option3 == this_value
            });
            load_this.updateVariantButton(condition, input)
            break;
          default:
        }
      });
      // n load change the size options js ends from here


          // const variant_image = this.updateSingleMedia(e.detail);
          // if(e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")){
          //   if(variant_image){
          //      var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}"]`).closest('.pro-media').dataset.index;
          //      var flkty = Flickity.data(e.target.closest(".card__inner").querySelector(".card__media .flickity_grid"));
          //      if(flkty){
          //       flkty.select(taeget_index)  
          //      }
          //   }
          // }else{
          //   if(variant_image){
          //     this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
          //     this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
          //   }
          //   this.closest('.product-card-wrapper').classList.add('variant_image_active');
          // }

          // card image change   
     
    //  const selectedInput = document.querySelector('.card-variation-color input[checked]');
    // const selected_sku = selectedInput ? selectedInput.dataset.sku : null;
    //       console.log(selected_sku);
      // const partsSku = selected_sku.split('--');
      // const matchSku = partsSku.length >= 2 ? partsSku[0] + '--' + partsSku[1] : selected_sku;
     
      // // Destroy previous Swipers
      // if (this.mainSwiper) this.mainSwiper.destroy(true, true);
      // if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
     
      // // Clear current Swiper wrappers
      // document.querySelector('.product-slider-gallery .swiper-wrapper').innerHTML = '';
      // document.querySelector('.thumbnail_slider_side .swiper-wrapper').innerHTML = '';
     
      // // Inject only matching slides
      // document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
      //   const alt = slide.getAttribute('data-image-alt') || '';
      //   if (alt.includes(matchSku)) {
      //     const clone = slide.cloneNode(true);
      //     clone.classList.add('swiper-slide');
      //     document.querySelector('.product-slider-gallery .swiper-wrapper').appendChild(clone);
      //   }
      // });

      
    }
    
    if (this.querySelector(".custom-select")) {
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
          e.target.nextElementSibling.classList.toggle("active");
        });
      });
    
      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
    
          let $optvalue = optval.target.innerHTML;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").innerHTML = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
    
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].innerHTML == $optvalue) {
              $s.options[i].selected = true;
    
              // Correct way to trigger change event
              let event = new Event('change', { bubbles: true });
              $s.dispatchEvent(event);
    
              break;
            }
          }
        });
      });
    }

    this.mainSwiper = null;
    this.thumbSwiper = null;
 
    // Wait until DOM + variant is ready
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        if(document.querySelector('.variation-color-wrapper')){
          const firstVariantSku = document.querySelector('.variation-color-wrapper .color_label input:checked')?.dataset.sku;
          if (firstVariantSku) {
            this.currentVariant = { sku: firstVariantSku };
            this.slideToSelectedVariant(firstVariantSku);
          } else {
            console.warn('No default variant selected');
            const firstColorLabel = document.querySelector('.variation-color-wrapper .color_label');
            const firstColorInput = document.querySelector('.variation-color-wrapper .color_label input');
            
            if (firstColorInput) {
              // Trigger the input directly
              firstColorInput.checked = true;
              firstColorInput.dispatchEvent(new Event('change', { bubbles: true }));
              
              // Or click the label
              // firstColorLabel.click();
            }
          }
        }
      }, 100);
    });
  }

  updateVariantButton(condition, input){
    if(condition){
      input.classList.remove('disabled')
    }else{
      input.classList.add('disabled')
    }
  }

  
  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item)=>{
      if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if(checked_count < fieldset.length ) return;
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updateVariantStatuses();
        
        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          // this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
        this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      


      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
    // if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
    //   // this.updateMedia(e.target.value);
    //   this.slideToSelectedVariant(e.target.value);
    // }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let enabledCounter = 0;
    const variant_form = this.querySelector('product-form').querySelector('form');
   
    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        // console.log("form submit",enabledCounter,inputWrappers.length,index)
        if(enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
      // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      // this.setInputAvailability(optionInputs, availableOptionInputsValue)

      // if(product_card && option.classList.contains('visually-hidden')) {
      //   product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
      //   const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
      //   this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
      // }
    });
  }
// quickAddToCart() {
//   const productFormEl = this.querySelector('product-form form');
//   if (!productFormEl) {
//     console.warn('Product form not found for quick add');
//     return;
//   }

//   const inputWrappers = [...this.querySelectorAll('.product-form__input')]
//     .filter(el => el.offsetParent !== null); // only visible/active inputs

//   // Check if every option has a valid selected input
//   const allOptionsSelected = inputWrappers.every(option => {
//     let selectedOptionInput = option.querySelector(':checked');
    
//     // If nothing is checked, pick the first available (non-disabled) option
//     if (!selectedOptionInput) {
//       selectedOptionInput = option.querySelector('input:not(.disabled)');
//       if (selectedOptionInput) {
//         selectedOptionInput.checked = true;
//       }
//     }

//     return (
//       selectedOptionInput &&
//       !selectedOptionInput.classList.contains('disabled')
//     );
//   });

//   // If all variant options are selected, submit the form
//   if (allOptionsSelected) {
//     productFormEl.dispatchEvent(new Event('submit', { bubbles: true }));
//     const cardWrapper = this.closest('.product-card-wrapper');
//     if (cardWrapper) {
//       cardWrapper.querySelector('.quick_add_loading')?.classList.remove('hidden');
//       cardWrapper.classList.add('adding_cart');
//     }
//   } else {
//     console.warn('Not all variant options are selected');
//   }
// }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    
    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);

    // this.getVariantData().find((variant) => {
    //   return !variant.options.map((option, index) => {
    //     return this.options[index] === option;
    //   }).includes(false);
    // });

    var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
    let main_images = [],
        thumb_images = [];

    for (let img_src of variant_images) {
      const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
      let main_img = document.createElement("li");
      main_img.classList.add(...main_classes);
      main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                    <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                    <div class="product__media media media--transparent has_zoom_element">
                          <img src="${img_src}&amp;width=1946" alt="">
                        </div>
                    </div>
                  </a>`;
      main_images.push(main_img);

      const thumb_classes = ['thumbnail-list__item', 'slider__slide']
      let thumb_img = document.createElement("li");
      thumb_img.classList.add(...thumb_classes);
      thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt=""></button>`;
      thumb_images.push(thumb_img);
    }

    // const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
    // const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
    // if(main_old_cells.length) {
    //   main_product_gallery.remove(main_old_cells);
    // }
    // main_product_gallery.insert( main_images, 0 );
    // main_product_gallery.select(0);

    // const thumb_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side[data-flickity]'));
    // const thumb_old_cells = thumb_gallery.cells.map(cell => cell.element);
    // if(thumb_old_cells.length) {
    //   thumb_gallery.remove(thumb_old_cells);
    // }
    // setTimeout(() =>{
    //   if(thumb_images.length>4) {
    //     thumb_gallery.insert( thumb_images, 0 );
    //   } else {
    //     let flktyOptions = JSON.parse(thumb_gallery.element.dataset.flickity);
    //     delete flktyOptions.wrapAround;
    //     flktyOptions.contain = true;
    //     thumb_gallery.insert( thumb_images, 0 );

    //     setTimeout(() =>{
    //       thumb_gallery.destroy();
    //       let new_flickity = new Flickity(thumb_gallery.element, flktyOptions);
    //       new_flickity.reposition();
    //     },50);
    //   }
    // },20);
  }
  
  // New version 
  slideToSelectedVariant(color) {
    // console.log("In slideToSelectedVariant " + color);
    const selected_sku = this.currentVariant?.sku || '';
    console.log("selected_sku",selected_sku,this.currentVariant);
    // console.log({color});
    const partsSku = selected_sku ? selected_sku.split('--') : [];
    const matchSku = partsSku.length >= 2 ? partsSku[0] + '--' + partsSku[1] : selected_sku;
    // console.log({matchSku});
    const getSortOrder = (alt) => {
      const match = alt.match(/-(\d+)$/);
      return match ? parseInt(match[1], 10) : Infinity;
    };

    // Destroy previous Swipers safely
    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);

    // Find wrappers
    const mainWrapper = document.querySelector('.product-slider-gallery .swiper-wrapper');
    const thumbWrapper = document.querySelector('.thumbnail_slider_side .swiper-wrapper');

    // ⚠️ Check existence before using
    if (!mainWrapper) {
      console.warn('Main Swiper wrapper not found: .product-slider-gallery .swiper-wrapper');
      return; // stop execution to avoid errors
    }

    // Clear current Swiper wrappers safely
    mainWrapper.innerHTML = '';
    if (thumbWrapper) thumbWrapper.innerHTML = '';

    const allMainSlides = document.querySelectorAll('#all-product-slides .product__media-item');
    const allThumbSlides = document.querySelectorAll('#all-product-slides .thumbnail-list__item');

    let matchedMainSlides = [];
    let matchedThumbSlides = [];

    if (selected_sku.trim() !== '') {
      allMainSlides.forEach(slide => {
        const alt = slide.getAttribute('data-image-alt') || '';
        
        let matchSkualt;
        
        if (alt.includes('--')) {
          // Already has double dash: PON--801-1 → PON--801
          const parts = alt.split('--');
          const secondPart = parts[1].split('-')[0];
          matchSkualt = parts[0] + '--' + secondPart;
        } else {
          // Single dash format
          const parts = alt.split('-');
          // Check if third part is purely numeric (image number) or contains letters (variant/color code)
          if (parts.length >= 3 && !/^\d+$/.test(parts[2])) {
            // Third part contains letters: YAROK-YA-G-2 → YAROK--YA-G
            matchSkualt = parts[0] + '--' + parts[1] + '-' + parts[2];
          } else if (parts.length >= 2) {
            // Simple format: PON-8-1 or PON-549B-3 → PON--8 or PON--549B
            matchSkualt = parts[0] + '--' + parts[1];
          } else {
            matchSkualt = selected_sku;
          }
        }
        console.log("matchSkualt",matchSkualt,"matchSku",matchSku)
        
        // console.log(matchSkualt + "----" + matchSku);
        if (matchSkualt == matchSku) matchedMainSlides.push(slide);
      });

      if (thumbWrapper) {
        allThumbSlides.forEach(slide => {
        const alt = slide.getAttribute('data-image-alt') || '';
        // console.log({alt});
        
        let matchSkualt;
        
        if (alt.includes('--')) {
          const parts = alt.split('--');
          const secondPart = parts[1].split('-')[0];
          matchSkualt = parts[0] + '--' + secondPart;
        } else {
          const parts = alt.split('-');
          if (parts.length >= 3 && !/^\d+$/.test(parts[2])) {
            matchSkualt = parts[0] + '--' + parts[1] + '-' + parts[2];
          } else if (parts.length >= 2) {
            matchSkualt = parts[0] + '--' + parts[1];
          } else {
            matchSkualt = alt;
          }
        }
        
        const isMatch = matchSkualt == matchSku;
        // console.log(matchSkualt + " == " + matchSku + " | Match: " + isMatch);
        
        if (isMatch) {
          // console.log("✓ PUSHING:", alt);
          matchedThumbSlides.push(slide);
        }
      });
      }
    }

    let finalMainSlides = matchedMainSlides.length > 0 ? matchedMainSlides : allMainSlides;
    let finalThumbSlides = matchedThumbSlides.length > 0 ? matchedThumbSlides : allThumbSlides;

    finalMainSlides = Array.from(finalMainSlides).sort((a, b) => {
      return getSortOrder(a.getAttribute('data-image-alt') || '') -
            getSortOrder(b.getAttribute('data-image-alt') || '');
    });

    finalThumbSlides = Array.from(finalThumbSlides).sort((a, b) => {
      return getSortOrder(a.getAttribute('data-image-alt') || '') -
            getSortOrder(b.getAttribute('data-image-alt') || '');
    });

    finalMainSlides.forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      mainWrapper.appendChild(clone);
    });

    if (thumbWrapper) {
      finalThumbSlides.forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        thumbWrapper.appendChild(clone);
      });
    }

    // Re-init Swipers only if wrapper exists
    if (thumbWrapper) {
      this.thumbSwiper = new Swiper('.thumbnail_slider_side', {
        watchOverflow: true,
        spaceBetween: 15,
        slidesPerView: 4,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        freeMode: true,
        loop: true,
        direction: "vertical",
        rtl: true,
      });
    }

    this.mainSwiper = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      loop: true,
      rtl: true,
      thumbs: thumbWrapper ? { swiper: this.thumbSwiper } : undefined,
    });

    this.mainSwiper.slideTo(0);
    if (thumbWrapper && this.thumbSwiper) this.thumbSwiper.slideTo(0);
  }



  updateSingleMedia(color) {
    const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
    const variant_img_src = single_variant_data.featured_image? single_variant_data.featured_image.src : false;

    return variant_img_src;
  }

  getVariantDetails(color) {
    return this.getVariantData().filter(data=>data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if(product_card) {
      // console.log("product_card",product_card)
        const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        // console.log(this.currentVariant,"current varriant")
        // input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      let $current_var_price = (this.currentVariant.price / 100).toFixed(2);
      // console.log($current_var_price);
      let $current_var_price_money = `₪ ${$current_var_price}`;
      document.querySelectorAll(".product__info-wrapper .change-price").forEach((e) => {
        e.innerHTML = $current_var_price_money;
        e.classList.add("price-updated");
      });
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if(inputWrappers[index - 1].querySelector(':checked')){
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
        if(product_card && option.classList.contains('visually-hidden')) {
          product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
          this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      // console.log('Here');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    // console.log("Current Variation ", this.currentVariant);
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if(product_card) {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
        const html = raw_html.querySelector('.single_main_product_wrapper');

        // const destination = document.getElementById(`price-${this.dataset.section}`);
        // const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        // const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // if (source && destination) destination.innerHTML = source.innerHTML;
        // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        // if (skuSource && skuDestination) {
        //   skuDestination.innerHTML = skuSource.innerHTML;
        //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        // }

        // const price = document.getElementById(`price-${this.dataset.section}`);

        // if (price) price.classList.remove('visibility-hidden');

        // if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {

        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        //Sale Detected
        if(html.getElementById(`product-form-${this.dataset.section}`)){
          if(html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`)){
            const isSale = html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`);
            if(isSale){
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "inline-block";
            }else{
              document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "none";
            }
          }
        }
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
          // addButton.classList.add("hidden");
          addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
          addButton.closest("product-form").classList.add("backinstock-active");
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
        if(document.querySelector(".backinstock_feature_enable")){
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
          addButton.classList.remove("hidden");
          addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
          addButton.closest("product-form").classList.remove("backinstock-active");
        }
      }
    }
    // console.log('Toggle done');
    // console.log(document.querySelector('variant-radios').currentVariant);
    clearTimeout(this._slideOnceTmr);
    this._slideOnceTmr = setTimeout(() => {
      // optional extra guard: only run if variant actually changed
      const vid = document.querySelector('variant-radios')?.currentVariant?.id;
      if (vid && this._lastSlideVariantId === vid) return;
      this._lastSlideVariantId = vid;

      this.slideToSelectedVariant("");
    }, 250);
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = this.querySelector(`#product-form-${this.dataset.section}`);
    if (!button) return; // stop if form not found

    const addButton = button.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton.querySelector('span');
    const price = this.querySelector(`#price-${this.dataset.section}`);
    const inventory = this.querySelector(`#Inventory-${this.dataset.section}`);
    const sku = this.querySelector(`#Sku-${this.dataset.section}`);

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

    // document.addEventListener('DOMContentLoaded', () => {
    //   setTimeout(() => {
    //     var first_var = document.querySelector('.variation-color-wrapper .color_label input:checked')?.dataset.sku;
    //     console.log(first_var, "first_var");
    //     var currentVariant = first_var;
    //     if (this.currentVariant && this.currentVariant.sku) {
    //       this.slideToSelectedVariant();
    //     }
    //   }, 100); // Give Shopify a moment to hydrate variant selection
    // });

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
  let firstAvailableInput = null;
  let selectedInput = null;

  listOfOptions.forEach(input => {
    const value = input.getAttribute('value');
    const isAvailable = listOfAvailableOptions.includes(value);

    if (input.checked) {
      selectedInput = input;
    }

    if (isAvailable) {
      input.classList.remove('disabled');
      if (!firstAvailableInput) {
        firstAvailableInput = input;
      }
    } else {
      input.classList.add('disabled');
    }
  });

  // If the selected input is now disabled, auto-select the first available after a delay
  // if (selectedInput && selectedInput.classList.contains('disabled') && firstAvailableInput) {
  //   setTimeout(() => {
  //     firstAvailableInput.checked = true;
  //     firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
  //   }, 200); // Adjust delay time in milliseconds as needed
  // }
}



  // updateOptions() {
  //   const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  //   this.options = fieldsets.map((fieldset) => {
  //     var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
  //     if(xx){
  //       if(xx.closest("fieldset.variation-color-wrapper") && xx.closest("fieldset.variation-color-wrapper").querySelector("legend span")){
  //           if(xx.closest(".swatch-input__label.color_label") && xx.closest(".swatch-input__label.color_label").querySelector(".variation-item-span")){
  //             let labeldata = xx.closest(".swatch-input__label.color_label").querySelector(".variation-item-span").getAttribute("data-label");
  //             // console.log("labeldata",labeldata)
  //             if(labeldata != "" || labeldata != null){
  //               xx.closest("fieldset").querySelector("legend span").innerHTML = labeldata;
  //             }else{
  //               xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
  //             }
  //           }
  //         }else if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")){
  //           xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
  //         }
        
  //       return xx.value;
  //     }else{
  //     }
  //   });
  // }
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.variants = JSON.parse(this.querySelector("script").innerHTML);
      this.options = fieldsets.map((fieldset) => {
        var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
        
        if(xx) {
          // Update legend label logic
          if(xx.closest("fieldset.variation-color-wrapper") && xx.closest("fieldset.variation-color-wrapper").querySelector("legend span")) {
            if(xx.closest(".swatch-input__label.color_label") && xx.closest(".swatch-input__label.color_label").querySelector(".variation-item-span")) {
              let labeldata = xx.closest(".swatch-input__label.color_label").querySelector(".variation-item-span").getAttribute("data-label");
              if(labeldata && labeldata !== "") {
                xx.closest("fieldset").querySelector("legend span").innerHTML = labeldata;
              } else {
                xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
              }
            }
          } else if(xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")) {
            xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
          }
          
          return xx.value;
        } else {
          return null;
        }
      });
      
      // Get selected color and size
      const selectedColor = this.options[0];
      const selectedSize = this.options[1];
      
      // Find variant with current selection
      const currentVariant = this.variants.find(v => 
        v.option1 === selectedColor && v.option2 === selectedSize
      );
      
      // ONLY if variant is UNDEFINED (doesn't exist), select first existing size
      if (currentVariant === undefined) {
        
        // Get first variant that EXISTS for this color (available or not)
        const firstExistingVariant = this.variants.find(v => v.option1 === selectedColor);
        
        if (firstExistingVariant) {
          const newSize = firstExistingVariant.option2;
          
          // Update options array
          this.options[1] = newSize;
          
          // Update the size radio button
          const sizeFieldset = fieldsets[1];
          
          if (sizeFieldset) {
            const sizeInputs = Array.from(sizeFieldset.querySelectorAll('input'));
            
            // Uncheck all
            sizeInputs.forEach(input => input.checked = false);
            
            // Check the valid one
            const validSizeInput = sizeInputs.find(input => input.value === newSize);
            
            if (validSizeInput) {
              validSizeInput.checked = true;
              
              // Update legend
              const legend = sizeFieldset.querySelector('legend span');
              if (legend) {
                legend.innerHTML = newSize;
              }
            }
          }
        }
      }
      // If variant EXISTS (available or not) → do nothing, keep selection
    }

}
customElements.define('variant-radios', VariantRadios);

// Handles card color selection
function ProductCardColor(e){
  if (!e) return;
  // console.log("-----Here-----");
  const selectedSkuload = e.dataset.sku;
  const partsSkuload = selectedSkuload.split('--');
  const matchSkuload = partsSkuload.length >= 2 ? `${partsSkuload[0]}--${partsSkuload[1]}` : selectedSkuload;
  const card_wrapperload = e.closest('.card-wrapper');
  if (!card_wrapperload) return;

  // console.log({selectedSkuload});
  // console.log({matchSkuload});
  const card_innerload = card_wrapperload.querySelector('.card__inner');
  if (!card_innerload) return;

  const flickityGridload = card_innerload.querySelector('.card__media .flickity_grid');
  const flktyload = flickityGridload ? Flickity.data(flickityGridload) : null;
  if (!flktyload) return;

  let matchingSlide = "";
  for (let slide of card_innerload.querySelectorAll('.card__media .pro-media')) {
    let altimage = slide.getAttribute('data-image-alt') || '';
    // console.log({altimage});
    let partsSkualtcard = altimage ? altimage.split(/--|-/) : [];
    let matchSkualtcard = partsSkualtcard.length >= 2 
      ? partsSkualtcard[0] + '--' + partsSkualtcard[1] 
      : selectedSkuload;

    if (matchSkualtcard === matchSkuload) {
      matchingSlide = slide;
      break;
    }
  }

  // if (matchingSlide) {
  //   const targetIndexload = parseInt(matchingSlide.dataset.index, 10);
  //   flktyload.select(targetIndexload);
  // }
}

// Initialize swatches and auto-select checked ones
function initProductCardColors(scope = document){
  scope.querySelectorAll(".card-variation-color input").forEach((swatch) => {
    swatch.removeEventListener("click", swatch._colorHandler); // remove old if exists
    const handler = (evt) => { ProductCardColor(evt.currentTarget); };
    swatch.addEventListener("click", handler);
    swatch._colorHandler = handler; // store reference
  });

  // Auto-trigger checked inputs
  scope.querySelectorAll(".card-variation-color input:checked").forEach((input) => {
    ProductCardColor(input);
  });
}

// Expose globally
window.ProductCardColor = ProductCardColor;
window.initProductCardColors = initProductCardColors;

// Run on page load for existing cards
document.addEventListener('DOMContentLoaded', () => {
  initProductCardColors();
});

// Default-select the first selectable color swatch on every product card.
// card-product.liquid renders the variant-option swatch row with no `checked`
// attribute, so those cards show no selected-color ring at all - only the cards
// built from `add_products_for_color_options` (a product per color) got one, via
// `.active_color`. With nothing selected the hidden color fieldset also never
// receives `color_change`: the size buttons keep the `select_color` class
// (pointer-events: none) and the mobile `+` stays locked, so the shopper taps
// add-to-cart and nothing happens.
function selectDefaultCardColorSwatch(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.card-variation-color').forEach((group) => {
    // `.custom_variation_button` scopes this to product-card swatches; the
    // complimentary-product row uses its own class and ships its own default.
    const swatches = group.querySelectorAll('input[type="radio"].custom_variation_button');
    if (!swatches.length) return;
    if (group.querySelector('input[type="radio"]:checked')) return;

    const selectable = Array.from(swatches).filter(
      (input) => !input.disabled && !input.classList.contains('disabled')
    );
    if (!selectable.length) return;

    // `data-default-color` is the color the product page opens on. Fall back to the
    // first swatch only when it is absent or its swatch isn't selectable.
    const wanted = (group.dataset.defaultColor || '').trim().toLowerCase();
    const first =
      (wanted && selectable.find((input) => input.value.trim().toLowerCase() === wanted)) ||
      selectable[0];

    first.checked = true;
    // `click` runs the swatch -> hidden color fieldset sync (which fires
    // `color_change` and unlocks the sizes); `change` swaps the card image.
    ['click', 'input', 'change'].forEach((type) => {
      first.dispatchEvent(new Event(type, { bubbles: true }));
    });
  });
}
window.selectDefaultCardColorSwatch = selectDefaultCardColorSwatch;

document.addEventListener('DOMContentLoaded', () => selectDefaultCardColorSwatch());

// Cards added after load: infinite scroll, recommendations, quick-add, AJAX filters.
// A batch can carry several cards at once, so the pass is run page-wide rather than
// per added node - it is cheap, because cards that already have a swatch selected
// are skipped.
(function observeDefaultCardColorSwatch() {
  if (!('MutationObserver' in window)) return;
  let scheduled = false;
  const reapply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      selectDefaultCardColorSwatch();
    });
  };
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('.card-variation-color') || node.querySelector?.('.card-variation-color')) {
          reapply();
          return;
        }
      }
    }
  });
  const start = () => observer.observe(document.body, { childList: true, subtree: true });
  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            if (window.initProductCardColors) {
              setTimeout(() => {
                initProductCardColors(this);
              }, 200);
            }
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            var elem = document.querySelector('#recomendation');
            var flkty = new Flickity( elem, {
                  "rightToLeft": true,
                  "cellAlign": "right",
                  "pageDots": false,
                  "wrapAround": true,
                  "responsive": [
                    {
                      "breakpoint": 750,
                      "settings": {
                        "wrapAround": true,
                        "contain": true,
                        "prevNextButtons": true,
                        "pageDots": false
                      }
                    }
                  ]
              });
              document.querySelectorAll("#recomendation .enable_image_slider .flickity_grid").forEach((elementItem) => {
                var flkty = new Flickity( elementItem, {
                  "imagesLoaded": true,
                  "rightToLeft": true,
                  "cellAlign": "right",
                  "pageDots": false,
                  "wrapAround": true,
                  "draggable": false,
                  "fade":true,
                  "responsive": [
                    {
                      "breakpoint": 750,
                      "settings": {
                        "freeScroll": true,
                        "wrapAround": false,
                        "contain": true,
                        "prevNextButtons": true,
                        "draggable": false,
                        "pageDots": false
                      }
                    }
                  ]
              });
              })
              const quickViewButtons = document.querySelectorAll(".mobile-quickview");
                if (quickViewButtons.length > 0) {
                    quickViewButtons.forEach((button) => {
                      button.addEventListener("click", (evt) => {
                        const cardWrapper = evt.target.closest(".card-wrapper");
                        if (!cardWrapper) return;
                        const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
                        quickAddButton?.click();
                        
                        const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='בחרי מידה']");
                        const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
                  
                        if (mobilePopupElement) {
                          const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
                          if (variationContainer && variantRadios) {
                            mobilePopupElement.classList.add("active");
                            let sizeVariantsHTML = "";
                            cardWrapper.querySelectorAll(".product-card_inline-variation input[name='בחרי מידה']").forEach((input) => {
                              let $disableClass;
                              if(input.classList.contains("disabled")){
                                $disableClass = "disabled";
                              }
                              // sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
                              sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant select_color" ${$disableClass}>${input.value}</button>`;
                            });
                            variationContainer.innerHTML = sizeVariantsHTML;
                          }
                        }
                      });
                    });
                  }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);





if(window.innerWidth < 750){
  // if(!document.querySelector(".gift-card-single-main-product")){
  //   if(document.querySelector(".single_main_product_wrapper")){
  //     var flkty = new Flickity( '.product__media-list.contains-media', {
  //       "imagesLoaded": true,
  //       "rightToLeft":true,
  //       "cellAlign":"right",
  //       "pageDots": true,
  //       "prevNextButtons": true,
  //       "wrapAround": true
  //   });
  //   }
  // }
  if(document.querySelector(".matat-mobile-zoom-btn")){
    document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
      document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
    })
  }
}
if(document.querySelector(".backinstock_feature_enable")){

  // backin stock feature for product page
if(document.querySelector(".single-main-product-page")){
  function validatePhoneNumber() {
    // Get and trim phone number input
    const phoneNumber = document.getElementById('stock-phone').value.trim();

    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }
  document.getElementById('stock-phone').addEventListener("keyup", (e)=>{
    let phone_value = e.target.value;
    if(phone_value != ""){
      validatePhoneNumber()
    }else{
      document.getElementById('phoneValidationMsg').textContent = "";
    }
  });
  document.querySelector(".matat-stock-notify-submit").addEventListener("click", ()=> {
  document.getElementById('phoneValidationMsg').textContent = '';  
  let check_phone = validatePhoneNumber();
  if (check_phone) {
              // Get data attributes from the button
              const button = document.querySelector(".matat-stock-notify-submit");
              const data = {
                  phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: button.getAttribute("data-id"),
                  product_id: button.getAttribute("data-product_id"),
                  action: button.getAttribute("data-action"),
                  title: (button.getAttribute("data-title")),
                  price_varies: JSON.parse(button.getAttribute("data-price_varies")),
                  price: (button.getAttribute("data-price")),
                  price_max: (button.getAttribute("data-price_max")),
                  price_min: (button.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
                  src: button.getAttribute("data-src"),
                  url: button.getAttribute("data-url"),
                  user_id: button.getAttribute("data-user_id"),
                  email: button.getAttribute("data-email"),
                  full_name: button.getAttribute("data-full_name"),
                  variant_id: button.getAttribute("data-variant-id"),
                  variant_title: button.getAttribute("data-variant-title")
              };

              fetch(`https://new-dreadlocks.myshopify.com/apps/text-me/restock-notifications`, {
                  method: 'POST', 
                  headers: {
                    "Content-Type": "application/json",
                    "x-shopify-shop-domain": Shopify.shop
                },
                body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('phoneValidationMsg').style.color = "green"
                document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';  
              })
              .catch(error => {
                  console.error('Error:', error);
              });
  } else {
      document.getElementById('phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
  }
  })
  document.querySelector('[name="id"]').addEventListener("change",(e)=>{
    let variant_change_val = e.target.value;
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id",variant_change_val);
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-id",variant_change_val);
  })
}
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
  super();
  this.addEventListener("click", () => {
    document.querySelector(".matat-product-card-stock").classList.toggle("active");
    document.body.classList.toggle("overflow-hidden");
    let $AllAttributes = this.attributes;
    this.copyAttributes($AllAttributes);
  })
}

copyAttributes(att){
  [...att].forEach((name) => {
    if(name.nodeName != "class"){
      document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
    }
  })
}

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closest(".matat-product-card-stock").classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      }
    })
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  if (check_phone) {
              // Get data attributes from the button
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch('https://new-dreadlocks.myshopify.com/apps/text-me/restock-notifications', {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
                      setTimeout(function(){
                        document.querySelector(".matat-product-card-stock").classList.remove("active");
                        document.body.classList.remove("overflow-hidden");
                      }, 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
                document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
                setTimeout(function(){
                  document.querySelector(".matat-product-card-stock").classList.remove("active");
                  document.body.classList.remove("overflow-hidden");
                }, 200);  
                
              })
              .catch(error => {
                  console.error('Error:', error);
              });
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
          document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

}


// login drawer focused css
// const loginPhoneInput = document.querySelector(".matat-login-main #login_phone");
// const otp_codeInput = document.querySelector(".matat-login-main #login_otp");
// const login_page_phoneInput = document.querySelector(".customer.login .matat-login-main #login_phone");
// const login_page_otp_codeInput = document.querySelector(".customer.login .matat-login-main #login_otp");
const toggleFocusClass = (e) => {
  if(e.target.closest(".floating_input_wrap")){
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if(e.type == "blur" && e.target.value != ""){
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  }else{
    if(e.target.closest(".floating_input_wrap")){
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }
    
  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})
// loginPhoneInput.addEventListener("focus", toggleFocusClass);
// loginPhoneInput.addEventListener("blur", toggleFocusClass);
// otp_codeInput.addEventListener("focus", toggleFocusClass);
// otp_codeInput.addEventListener("blur", toggleFocusClass);
// if(login_page_phoneInput){
//   login_page_phoneInput.addEventListener("focus", toggleFocusClass);
//   login_page_phoneInput.addEventListener("blur", toggleFocusClass);
// }
// if(login_page_otp_codeInput){
//   login_page_otp_codeInput.addEventListener("focus", toggleFocusClass);
//   login_page_otp_codeInput.addEventListener("blur", toggleFocusClass);
// }
class GoogleLoginBtn extends HTMLElement{
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) =>{
  if(e.target.classList.contains("modal-overlay") && e.target.closest("details").hasAttribute("open")){
      e.target.closest("details").removeAttribute("open");
      document.querySelector(".section-header").classList.remove("menu-open");
  }
  if(e.target.classList.contains("extra_color_button")){
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }
  if(e.target.classList.contains("mobile-popup-variant")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    if (!$elementVariant) return;
    var evt = document.createEvent("HTMLEvents");
        evt.initEvent("change", false, true);
        $elementVariant.click();
        $elementVariant.dispatchEvent(evt);
    const cardWrapper = $elementVariant.closest(".card-wrapper");
    const submitBtn = cardWrapper?.querySelector(".product-form__submit, .quick-add__submit");
    if (submitBtn) {
      setTimeout(() => submitBtn.click(), 100);
    }
  }
  if(e.target.classList.contains("product-vars-inner-main-popup")){
    e.target.classList.remove("active");
  }
  if(e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")){
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  // mobile quick view js starts from here 
  // old js backup do not delete!
  // if(e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")){
  //     // const quickViewButtons = document.querySelectorAll(".mobile-quickview");
  //     // if (quickViewButtons.length > 0) {
  //       // quickViewButtons.forEach((button) => {
  //         // button.addEventListener("click", (evt) => {
  //         // });
  //       // });
  //     // }
  //     const cardWrapper = e.target.closest(".card-wrapper");
  //       if (!cardWrapper) return;
  //       const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
  //       quickAddButton?.click();
        
  //       // const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='בחרי מידה']");
  //       const variantRadios = cardWrapper.querySelectorAll(
  //         ".product-card_inline-variation input[name='בחרי מידה'], .product-card_inline-variation input[name='size'], .product-card_inline-variation input[name='Size']"
  //       );
  //       const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");

  //   if(variantRadios){
  //       if (mobilePopupElement) {
  //         const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
  //         if (variationContainer && variantRadios) {
  //           mobilePopupElement.classList.add("active");
  //           let sizeVariantsHTML = "";
  //           cardWrapper.querySelectorAll(".product-card_inline-variation input[name='בחרי מידה'], .product-card_inline-variation input[name='size'], .product-card_inline-variation input[name='Size']").forEach((input) => {
  //             let $disableClass;
  //             if(input.classList.contains("disabled")){
  //               $disableClass = "disabled";
  //             }
  //             sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
  //           });
  //           variationContainer.innerHTML = sizeVariantsHTML;
  //         }
  //       }
  //   }else{
  //         cardWrapper.querySelector(".card__inner .product_quick_add_wrap .default_variant_card input[type='radio']").click();
  //       }
  //   }
  
    // New Js
    if (e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")) {
      const cardWrapper = e.target.closest(".card-wrapper");
      if (!cardWrapper) return;
    
      // All non-color variant radios (covers Size/Length/etc. regardless of option name)
      // - fieldset:not(.listen_color_change) excludes the hidden color fieldset
      // - [name] excludes the placeholder "add to cart" radio rendered for color-only products
      // - filter out name="title" so default-variant-only products go straight to add-to-cart
      const variantRadios = Array.from(
        cardWrapper.querySelectorAll(
          ".product-card_inline-variation fieldset:not(.listen_color_change) input[type='radio'][name]"
        )
      ).filter((input) => input.getAttribute("name") !== "title");

      const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");

      if (variantRadios.length > 0 && mobilePopupElement) {
        const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
        if (variationContainer) {
          mobilePopupElement.classList.add("active");

          let sizeVariantsHTML = "";
          variantRadios.forEach((input) => {
            const isDisabled = input.classList.contains("disabled") ? "disabled" : "";
            sizeVariantsHTML += `<button type="button" value="${input.id}" class="mobile-popup-variant" ${isDisabled}>${input.value}</button>`;
          });

          variationContainer.innerHTML = sizeVariantsHTML;
        }
      } else {
        // No non-color variants: submit the inline product form (or open the quick-add modal in modal mode)
        const submitBtn = cardWrapper.querySelector(".product-form__submit, .quick-add__submit");
        submitBtn?.click();
      }
    }

    // New js end
  // ends here
})
document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector(".header-icon-search-mobile").addEventListener("click", ()=>{
    if(document.querySelector(".header__search details").hasAttribute("open")){
      document.querySelector(".section-header").classList.remove("menu-open");
    }else{
      document.querySelector(".section-header").classList.add("menu-open");
    }
    if(document.querySelector("#Details-menu-drawer-container").hasAttribute("open")){
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded",false);
      document.body.classList.remove("overflow-hidden-tablet")
    }
   })  
   if(document.body.classList.contains("product-template")){
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
      scrollToTop()
   }
});
document.addEventListener('DOMContentLoaded', function () {
  const targetContainer = document.querySelector('#size_chart_content');
  const targetColorCard = document.querySelector(".card-variation-color input:checked")

  if (targetContainer) {
    fetch('https://new-dreadlocks.myshopify.com/pages/size-chart')
      .then(response => response.text())
      .then(html => {
        // Create a temporary container to parse the HTML
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        // Find all .size_chart_table elements
        const sizeChartTables = tempDiv.querySelectorAll('.sizechart_tables');
        // console.log(sizeChartTables);

        // Clear the container before adding new content
        targetContainer.innerHTML = '';

        // Append each found size_chart_table to the container
        sizeChartTables.forEach(table => {
          targetContainer.appendChild(table.cloneNode(true)); // clone to avoid DOM relocation
        });

        // Re-initialize script after content is added
        initSizeChartScripts();
      })
      .catch(err => {
        console.error('Error loading size chart:', err);
      });
  }
    if (targetColorCard) {
      setTimeout(() => {
        document.querySelectorAll('.card-variation-color input:checked').forEach(input => {
          ProductCardColor(input);
        });
      }, 200); // delay in milliseconds (1000ms = 1 second)
    }  

  function initSizeChartScripts() {
    const optionButtons = document.querySelectorAll('.option_btn');
    const tables = document.querySelectorAll('.size_chart_tables');

    optionButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tableId = button.getAttribute('data-table');

        tables.forEach(table => table.classList.remove('active'));

        const selectedTable = document.querySelector(`.size_chart_tables[data-table="${tableId}"]`);
        if (selectedTable) {
          selectedTable.classList.add('active');
        }

        optionButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  function ProductCardColor(e){
    // console.log("Here-------------");
    const selectedSkuload = e.dataset.sku;
    const partsSkuload = selectedSkuload.split('--');
    const matchSkuload = partsSkuload.length >= 2 ? `${partsSkuload[0]}--${partsSkuload[1]}` : selectedSkuload;
    const card_wrapperload = e.closest('.card-wrapper'); // ✅ Finds the parent card
    if (!card_wrapperload) {
      console.warn('No .card-wrapper found');
      return;
    }

    const card_innerload = card_wrapperload.querySelector('.card__inner'); // ✅ Scoped inside wrapper
    if (!card_innerload) {
      console.warn('No .card__inner inside .card-wrapper');
      return;
    }

    const flickityGridload = card_innerload.querySelector('.card__media .flickity_grid');
    const flktyload = flickityGridload ? Flickity.data(flickityGridload) : null;

    // No carousel on the card (settings.enable_image_slider off) - nothing to slide.
    if (!flktyload) return;
    let matchingSlide = "";
    for (let e of card_innerload.querySelectorAll(`.card__media .pro-media`)) {
      let altimage = e.getAttribute('data-image-alt') || '';
      let partsSkualtcard = altimage ? altimage.split(/--|-/) : [];
      let matchSkualtcard = partsSkualtcard.length >= 2 
        ? partsSkualtcard[0] + '--' + partsSkualtcard[1] 
        : selectedSkuload;
      if (matchSkualtcard === matchSkuload) {
        matchingSlide = e;
        break;
      }
    }
    if (matchingSlide) {
      const targetIndexload = parseInt(matchingSlide.dataset.index, 10);
      flktyload.select(targetIndexload);
    } else {
      console.warn('No matching slide found');
    }
  }
  window.ProductCardColor = ProductCardColor;
});

// Loyalty club modal to login modal 
// document.querySelector('.already-has-account-btn')
//   .addEventListener('click', function (event) {
//   event.preventDefault();
//   const loginBtn = document.querySelector('.header-login-btn');
//   if (loginBtn) {
//     loginBtn.click();
//   }
// });
document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('.already-has-account-btn');
  if (btn) {
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      const loginBtn = document.querySelector('.header-login-btn');
      if (loginBtn) loginBtn.click();
    });
  }
});

document.addEventListener("click", (e) => {
  const card = e.target.closest(".card-mobile-quickview.select_color")?.closest(".card-wrapper");
  const tooltip = card?.querySelector(".tooltip_text");
  if (!tooltip) return;

  tooltip.classList.remove("hidden");
  setTimeout(() => tooltip.classList.add("hidden"), 2000);
});
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.card__inner .variant-button input.select_color').forEach(function (input) {
        input.classList.remove('disabled');
    });
});

// Cards using the cross-product color-as-link pattern (metafield add_products_for_color_options)
// have no in-product color radio to "select", so unblock the mobile quick-add `+` for them.
// Detection: the color fieldset (.listen_color_change) contains no input.select_color.
function unblockQuickAddForNoColorSelection(root) {
  const scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll('.card-mobile-quickview.select_color').forEach((el) => {
    const card = el.closest('.card-wrapper');
    if (!card) return;
    const hasSelectableColor = card.querySelector(
      '.product-card_inline-variation .listen_color_change input.select_color'
    );
    if (!hasSelectableColor) {
      el.classList.remove('select_color');
    }
  });
}
window.unblockQuickAddForNoColorSelection = unblockQuickAddForNoColorSelection;
document.addEventListener('DOMContentLoaded', () => unblockQuickAddForNoColorSelection());
new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (
        (node.matches && node.matches('.card-wrapper, .card-mobile-quickview')) ||
        (node.querySelector && node.querySelector('.card-mobile-quickview.select_color'))
      ) {
        unblockQuickAddForNoColorSelection(node);
        break;
      }
    }
  }
}).observe(document.body, { childList: true, subtree: true });
// Product card: show second image on hover (non-slider cards).
// Card images carry inline opacity styles (also set by the variant swatch logic),
// so the CSS-only hover rules can't override them; swap the visible image here instead.
(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (min-width: 990px)');
  const getImages = (wrapper) => {
    const media = wrapper.querySelector('.card__media .media.media--hover-effect');
    return media ? Array.from(media.querySelectorAll(':scope > img.pro-media')) : [];
  };

  document.addEventListener('mouseenter', (e) => {
    const wrapper = e.target;
    if (!hoverQuery.matches || !(wrapper instanceof Element) || !wrapper.matches('.card-wrapper')) return;
    if (wrapper.classList.contains('variant_image_active')) return;
    const images = getImages(wrapper);
    if (images.length < 2) return;

    // Topmost visible image is the last one with opacity 1 (later siblings stack above earlier ones).
    let currentIndex = 0;
    images.forEach((img, i) => { if (img.style.opacity === '1') currentIndex = i; });
    const next = images[(currentIndex + 1) % images.length];
    const saved = images.map((img) => img.style.opacity);
    images.forEach((img) => { img.style.opacity = img === next ? '1' : '0'; });
    wrapper._hoverSwap = { images, saved, next };
  }, true);

  document.addEventListener('mouseleave', (e) => {
    const wrapper = e.target;
    if (!(wrapper instanceof Element) || !wrapper._hoverSwap) return;
    const { images, saved, next } = wrapper._hoverSwap;
    delete wrapper._hoverSwap;
    // Skip restoring if a variant swatch changed the visible image during hover.
    if (next.style.opacity !== '1') return;
    images.forEach((img, i) => { img.style.opacity = saved[i]; });
  }, true);
})();
